export default __webpack_public_path__ + "static/media/harvey.1d1a7373.png";